__turbopack_context__.v({
  "wrapper": "Wrapper-module-scss-module__-bVzJG__wrapper",
});
